import React from 'react';
import Search from 'components/bdtx/kpi/detail-by-organization/search';

const OverviewDeployment = () => <Search />;

export default OverviewDeployment;
